module.exports = __webpack_public_path__ + "static/media/footer_bg.e8238164.png";